import React from "react";
import LoginScreen from "./LoginScreen";

class aiLogin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      mobile: false,
    };
    document.cookie = "cartCounter=25;";
  }

  componentDidMount() {
    this.checkDevice();
  }

  checkDevice = () => {
    /* Storing user's device details in a variable*/
    let details = navigator.userAgent;

    /* Creating a regular expression  
      containing some mobile devices keywords  
      to search it in details string*/
    let regexp = /android|iphone|kindle|ipad/i;

    /* Using test() method to search regexp in details 
      it returns boolean value*/
    let isMobileDevice = regexp.test(details);

    if (isMobileDevice) {
      this.setState({ mobile: true });
    } else {
      this.setState({ mobile: false });
    }
  };

  Fnavbar = () => {
    let Usernavbar = LoginScreen();
    return Usernavbar;
  };

  render() {
    return (
      <React.Fragment>
        <this.Fnavbar />
      </React.Fragment>

      //   <div style={{ paddingLeft: 200 }}>
      //     <h3>Welcome to Enhance Images!</h3>
      //   </div>
    );
  }
}
export default aiLogin;
